import _ from 'lodash'
import { getDateObjectFromPeriodString, getYearAndMonthStringFromDateObject } from '@utils/date-helpers'

export const transformPeriod = (item) => {
  const dateObject = getDateObjectFromPeriodString(item)
  const { month, year } = getYearAndMonthStringFromDateObject(dateObject)

  return {
    month,
    year,
    label: `${month} ${year}`,
    timestamp: dateObject,
    rawApiPeriod: item,
  }
}

export const transformManyPeriods = (items) => {
  return items.map((item) => transformPeriod(item))
}

export const transformLeaderboardData = (item, leaderboardCategory = '') => {
  const leaderboardType = item.user_id ? 'User' : 'Office'
  const name = leaderboardType === 'User' ? `${item.first_name} ${item.last_name}` : item.offices.split('-')[0]
  const addresses = leaderboardType === 'User' ? item.offices.split('|') : [item.offices.split('-').slice(1).join('-')]
  const isUnit = leaderboardCategory.toLowerCase().includes('unit')
  return {
    leaderboardType,
    name,
    addresses,
    isUnit,
    isWorkingLocation: item.workingLocation,
    userId: item.user_id,
    rank: item.rank,
    rankValue: item.rankValue,
  }
}

export const transformManyLeaderboardData = (items) => {
  return Object.fromEntries(
    Object.entries(items).map(([key, value]) => {
      return [key, _.values(value).map((item) => transformLeaderboardData(item, key))]
    })
  )
}

export const transformManyRankingData = (items) => {
  return _.mapValues(items, transformManyLeaderboardData)
}
